"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ADD_ARENA: function() {
        return ADD_ARENA;
    },
    DELETE_ARENA: function() {
        return DELETE_ARENA;
    },
    GENERATE_ARENAS: function() {
        return GENERATE_ARENAS;
    },
    RESET_ARENAS: function() {
        return RESET_ARENAS;
    },
    UPDATE_ARENA: function() {
        return UPDATE_ARENA;
    }
});
const ADD_ARENA = "ADD_ARENA";
const UPDATE_ARENA = "UPDATE_ARENA";
const DELETE_ARENA = "DELETE_ARENA";
const GENERATE_ARENAS = "GENERATE_ARENAS";
const RESET_ARENAS = "RESET_ARENAS";
